import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import CenterService from '../../../services/centers/center.service.js'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions.js'
import DataTableComp from '../../../components/common/data-table/DataTableComp.jsx'
import Modal from '../../../components/modal/Modal.jsx'
import useModal from '../../../utils/hooks/useModal.js'
import { formatDate } from '../../../utils/helpers/format.js'
import { urlBack } from './utils/center.utils.ts'
import CenterMaintenanceForm from './form/CenterMaintenanceForm.tsx'
import CheckboxCom from '../../../components/common/form-components/checkbox/CheckboxComp.jsx'
import CenterSection from './common/CenterSection.tsx'
import AppButton from '../../../component/common/AppButton.tsx'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'
import AppModal from '../../../component/layout/AppModal.tsx'
import { useTranslation } from 'react-i18next'
import { useDisclosure } from '@mantine/hooks'

const CenterMaintenances = () => {
  const { t } = useTranslation()
  const { formatDate: formatDateInl } = useIntl()

  const [opened, { open, close }] = useDisclosure(false)

  const { isShowing, toggle } = useModal()
  const { id } = useParams()

  const [currentCenter, setCurrentCenter] = useState()
  const [selectedItem, setSelectedItem] = useState()

  const navigate = useNavigate()

  useEffect(() => {
    getCenterData()
  }, [])

  useEffect(() => {
    if (!opened) {
      dataFacade?.reload()
      setSelectedItem()
    }
  }, [opened])

  // const handleToggle = (noReset) => {
  //   if (!noReset) setSelectedItem()
  //   toggle()
  //   dataFacade.reload()
  // }

  const getCenterData = async () => {
    if (id && id !== 'undefined') {
      const response = await CenterService.getById(id)
      if (response) {
        setCurrentCenter(response.resp)
      }
    }
  }

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'revisionDate',
    getAll: ({ filter, sort, limit, skip }) =>
      CenterService?.maintenances?.getAll({ id, filter, sort, limit, skip }),
  })

  // const headerOptions = {
  //   title: currentCenter?.basicData?.name,
  //   // searchOptions: dataFacade?.searchOptions,
  //   handlerHeaderActions: {
  //     showBackButton: true,
  //     backButton: () => navigate(urlBack(currentCenter?.centerType)),

  //     secondaryButton: () => {
  //       handleToggle()
  //     },
  //     secondaryButtonText: 'button.add',
  //     secondaryButtonIcon: 'pi-plus',
  //   },
  // }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const renderBool = (checked) => {
    return <CheckboxCom disabled checked={checked === true} />
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        editMode: 'row',
        selectionMode: 'single',
        selection: selectedItem,
        onRowSelect: (e) => {
          setSelectedItem(e?.data)
          // handleToggle(true)
          open()
        },
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column
          sortable
          field="date"
          header={t('date')}
          style={{ minWidth: '200px', width: '10%' }}
          body={({ date }) => formatDate({ date, formatDateInl })}
        />,
        <Column
          sortable
          field="maintenanceType.name"
          header={t('name')}
          style={{ width: '60%' }}
        />,
        <Column
          sortable
          field="revisionDate"
          header={t('revisionDate')}
          body={(rowData) =>
            formatDate({ date: rowData?.revisionDate, formatDateInl })
          }
        />,
        <Column
          sortable
          field="endDate"
          header={t('endDate')}
          body={(rowData) =>
            formatDate({ date: rowData?.endDate, formatDateInl })
          }
        />,
        <Column sortable field="user.name" align="right" header={t('user')} />,
      ]}
    />
  )

  return (
    <CenterSection
      toolbar={
        <AppToolbar
          rightSection={[
            <AppButton
              preset="back"
              onClick={() => navigate(urlBack(currentCenter?.centerType))}
            />,
            <AppButton preset="add" onClick={() => open()} />,
          ]}
        />
      }
    >
      {dataTable}
      <AppModal
        title={t(selectedItem ? 'maintenance' : 'center.maintenance.add')}
        opened={opened}
        close={close}
      >
        <CenterMaintenanceForm
          centerId={id}
          selectedItem={selectedItem}
          close={close}
        />
      </AppModal>
    </CenterSection>
  )
}

export default CenterMaintenances
